import { IAppState } from '../../redux';
import { EServiceId } from '../../redux/reducers';

export function selectDefaultServiceId(state: IAppState): EServiceId | null {
  const {
    publishTerms: { services },
  } = state;

  const defaultService = Object.values(services).find(({ isDefault }) => isDefault);

  return defaultService ? defaultService.id : null;
}
